import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import DistrictReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/district.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(DistrictReducer, defaultState, asyncActions);
};

type IDistrictContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const DistrictContext = createContext<Partial<IDistrictContext>>({
  state: defaultState,
}) as React.Context<IDistrictContext>;

const DistrictProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <DistrictContext.Provider value={{ ...reducer }}>
      {children}
    </DistrictContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useDistrictContext = () => useContext(DistrictContext);

export type IuseDistrictContext = ReturnType<typeof useDistrictContext>;

export { DistrictContext, DistrictProvider };
